import * as React from 'react';
import { Button, Drawer } from 'antd';
import { L } from '../../../../lib/abpUtility'; 
import { FullscreenOutlined } from '@ant-design/icons';
 

export interface IDashboardFilterDrawerProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    onCancel: () => void;
}


export class DashboardFilterDrawer extends React.Component<IDashboardFilterDrawerProps> {

    state = {

    };

    render() {
        const { visible, onCancel } = this.props; 

        return (
            <Drawer closeIcon={false} className="font-face-gm" height="75" placement="top" style={{ textAlign: 'center' }} onClose={onCancel} open={visible} >
                <div style={{ fontSize: '2.5em', marginTop: '-15px', marginBottom: '-15px', float: 'left' }}>{L('Views')}</div>
                <div style={{ fontSize: '2.5em', marginTop: '-15px', marginBottom: '-15px', float: 'right' }}>
                    <Button className="font-face-gm" 
                    //onClick={() => this.props.cardEdit({ id: this.props.id })} 
                    style={{ minWidth: '50px', marginRight: '10px', backgroundColor: this.props.primaryColor, borderColor: 'white' }} type="primary">
                        {L('Fullscreen')} <FullscreenOutlined />
                    </Button></div>
            </Drawer>
        );
    }
}

export default DashboardFilterDrawer;
